import React from 'react';
import { ChevronDown } from 'lucide-react';

export const CHECKBOX_CLASS =
  'w-5 h-5 rounded border-2 border-[#6BABA0] text-[#6BABA0] focus:ring-[#6BABA0]/40 cursor-pointer accent-[#6BABA0]';

const TEAL_BORDER = 'border-[#6BABA0]';

/**
 * Reusable collapsible panel with checkbox list and optional description field.
 */
const CollapsibleCheckboxSection = ({
  title,
  isExpanded,
  onToggle,
  items = [],
  selectedMap = {},
  onToggleItem,
  onSelectAll,
  allSelected = false,
  description = '',
  onDescriptionChange,
  categoryLabel = 'Category',
  descriptionLabel = 'Description',
  showDescription = true,
  selectAllLabel = 'Select all',
}) => {
  return (
    <div className={`rounded-xl border-2 ${TEAL_BORDER} overflow-hidden bg-white/60`}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-white/80 transition-colors"
      >
        <span className="text-base font-medium text-black font-['Open_Sans']">{title}</span>
        <ChevronDown
          className={`w-5 h-5 text-gray-600 flex-shrink-0 transition-transform ${
            isExpanded ? 'rotate-180' : ''
          }`}
          strokeWidth={2}
        />
      </button>

      {isExpanded && (
        <div className="px-4 pb-4 flex flex-col gap-3 border-t border-[#6BABA0]/30">
          <div className="flex items-center justify-between pt-3">
            <span className="text-sm font-medium text-black font-['Open_Sans']">
              {categoryLabel}
            </span>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                className={CHECKBOX_CLASS}
                checked={allSelected}
                onChange={e => onSelectAll?.(e.target.checked)}
              />
              <span className="text-sm text-gray-500 font-['Open_Sans']">{selectAllLabel}</span>
            </label>
          </div>

          <div className="flex flex-col gap-2">
            {items.map(item => (
              <label
                key={item.id}
                className="flex items-center gap-3 px-3 py-3 rounded-xl bg-white border border-zinc-200 cursor-pointer hover:border-[#6BABA0]/50 transition-colors"
              >
                <input
                  type="checkbox"
                  className={CHECKBOX_CLASS}
                  checked={!!selectedMap[item.id]}
                  onChange={() => onToggleItem?.(item.id)}
                />
                <span className="text-base text-black font-['Open_Sans']">{item.label}</span>
              </label>
            ))}
          </div>

          {showDescription && (
            <div className="flex flex-col gap-2">
              <span className="text-sm font-medium text-black font-['Open_Sans']">
                {descriptionLabel}
              </span>
              <textarea
                value={description}
                onChange={e => onDescriptionChange?.(e.target.value)}
                placeholder="Enter description"
                rows={3}
                className="w-full px-4 py-3 rounded-xl bg-white border border-zinc-300 text-base text-black font-['Open_Sans'] placeholder:text-gray-400 resize-none focus:outline-none focus:ring-2 focus:ring-[#6BABA0]/40 focus:border-[#6BABA0]"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CollapsibleCheckboxSection;
